import { render, staticRenderFns } from "./afterSalesDocumentDetail.vue?vue&type=template&id=4cc8d482&scoped=true"
import script from "./afterSalesDocumentDetail.vue?vue&type=script&lang=js"
export * from "./afterSalesDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDocumentDetail.vue?vue&type=style&index=0&id=4cc8d482&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8d482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc8d482')) {
      api.createRecord('4cc8d482', component.options)
    } else {
      api.reload('4cc8d482', component.options)
    }
    module.hot.accept("./afterSalesDocumentDetail.vue?vue&type=template&id=4cc8d482&scoped=true", function () {
      api.rerender('4cc8d482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/afterSalesDocumentDetail.vue"
export default component.exports